export const CYPRESS_DATA_ATTRIBUTES = {
    GRID_CELL_INPUT: 'GRID_CELL_INPUT',
};
